import { GetterTree } from "vuex";
import {
  IApprovalDelegation,
  IApprovalRequestDetail,
  IApprovalRequestListItem,
  IApprovalRequestsState,
} from "../types";
import { StoreState } from "@/store/type";

const getters: GetterTree<IApprovalRequestsState, StoreState> = {
  approvalRequests: (state): IApprovalRequestListItem[] =>
    state.approvalRequests || [],
  selectedApprovalRequest: (state): IApprovalRequestDetail | null =>
    state.selectedApprovalRequest,
  approvalRequestsTotalRecords: (state): number => state.totalRecords,
  approvalRequestsPage: (state): number => state.page,
  approvalRequestsPageSize: (state): number => state.pageSize,
  isFetchingApprovalRequests: (state): boolean =>
    state.isFetchingApprovalRequests,
  isFetchingApprovalRequestDetail: (state): boolean =>
    state.isFetchingApprovalRequestDetail,
  isApprovalRequestActionLoading: (state): boolean =>
    state.isApprovalRequestActionLoading,
  approvalDelegations: (state): IApprovalDelegation[] =>
    state.approvalDelegations || [],
  assignedApprovalDelegations: (state): IApprovalDelegation[] =>
    state.assignedApprovalDelegations || [],
  isFetchingApprovalDelegations: (state): boolean =>
    state.isFetchingApprovalDelegations,
  isFetchingAssignedApprovalDelegations: (state): boolean =>
    state.isFetchingAssignedApprovalDelegations,
  approvalDelegationActionLoading: (state): boolean =>
    state.approvalDelegationActionLoading,
};

export default getters;
